export default "__VITE_ASSET__mwNo26Sz__"